import type {SVGProps} from 'react'
import {useId} from 'react'
const CustomMadeIcon = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '')
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      width="1em"
      height="1em"
      overflow="visible"
      style={{
        display: 'block',
      }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Outline">
        <g id="Intersect">
          <path
            d="M14.6 8H16C16 3.58172 12.4183 0 8 0V1.4C11.6451 1.4 14.6 4.35492 14.6 8Z"
            fill="var(--fill-0, #2D2E2C)"
          />
          <path
            d="M14.6 8H16C16 3.58172 12.4183 0 8 0V1.4C11.6451 1.4 14.6 4.35492 14.6 8Z"
            fill={`url(#${uid}paint0_linear_13120_20378)`}
          />
        </g>
        <g id="Intersect_2">
          <path
            d="M14.6 8C14.6 11.6451 11.6451 14.6 8 14.6V16C12.4183 16 16 12.4183 16 8H14.6Z"
            fill="var(--fill-0, #2D2E2C)"
          />
          <path
            d="M14.6 8C14.6 11.6451 11.6451 14.6 8 14.6V16C12.4183 16 16 12.4183 16 8H14.6Z"
            fill={`url(#${uid}paint1_linear_13120_20378)`}
          />
        </g>
        <g id="Intersect_3">
          <path
            d="M1.4 8H0C0 12.4183 3.58172 16 8 16V14.6C4.35492 14.6 1.4 11.6451 1.4 8Z"
            fill="var(--fill-0, #2D2E2C)"
          />
          <path
            d="M1.4 8H0C0 12.4183 3.58172 16 8 16V14.6C4.35492 14.6 1.4 11.6451 1.4 8Z"
            fill={`url(#${uid}paint2_linear_13120_20378)`}
          />
        </g>
        <g id="Intersect_4">
          <path
            d="M8 0C3.58172 0 0 3.58172 0 8H1.4C1.4 4.35492 4.35492 1.4 8 1.4V0Z"
            fill="var(--fill-0, #2D2E2C)"
          />
          <path
            d="M8 0C3.58172 0 0 3.58172 0 8H1.4C1.4 4.35492 4.35492 1.4 8 1.4V0Z"
            fill={`url(#${uid}paint3_linear_13120_20378)`}
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={`${uid}paint0_linear_13120_20378`}
          x1={8}
          y1={1.14286}
          x2={14.8571}
          y2={8}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2085CE" />
          <stop offset={0.0498047} stopColor="#2387C7" />
          <stop offset={1} stopColor="#58B64A" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint1_linear_13120_20378`}
          x1={14.8571}
          y1={8}
          x2={8}
          y2={14.8571}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58B64A" />
          <stop offset={1} stopColor="#DC9F1C" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint2_linear_13120_20378`}
          x1={8}
          y1={14.8571}
          x2={1.14286}
          y2={8}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DC9F1C" />
          <stop offset={1} stopColor="#E42922" />
        </linearGradient>
        <linearGradient
          id={`${uid}paint3_linear_13120_20378`}
          x1={1.14286}
          y1={8}
          x2={8}
          y2={1.14286}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E42922" />
          <stop offset={1} stopColor="#2085CE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
export {CustomMadeIcon}
